import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import {server} from './constants'

@Injectable()
export class ClientsService {

    private httpAddress = server;



  constructor(private http: HttpClient) { }

  getClients():Promise<any>{
    // get the clients from tblqbcust and return
    return this.http.get(this.httpAddress +'api/clients/get')
    .toPromise()
    .then(clients => clients)
    .catch(err => console.log(err))
  }

  getWhseClients(): Promise<any> {
    // get client list from lgltrax.
    return this.http.get(this.httpAddress  + 'api/clients/whse')
    .toPromise()
    .then(clients => clients)
    .catch(err => console.log(err));
  }

  getSubClients(clientid): Promise<any>{
    // get list of palletids like pallet id limit 20 return list
    return this.http.get(this.httpAddress + 'api/clients/subclients/' + clientid)
    .toPromise()
    .then(subclients => subclients)
    .catch(err => console.log(err));
  }

  getSelectedClient(id):Promise<any>{
    // get the selected client then return info also put in localStorage
    return this.http.get(this.httpAddress +'api/clients/selected/' + id)
    .toPromise()
    .then(selectedClient => selectedClient)
    .catch(err => console.log(err))
  }

}



// WEBPACK FOOTER //
// ./src/app/services/clients.service.ts